var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerifiedBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "verified-badge",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.621,
    height: 25.686,
    viewBox: "0 0 24.621 25.686",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2620",
    "data-name": "Group 2620",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1689",
    "data-name": "Path 1689",
    d: "M13.551.446a1.95,1.95,0,0,0-2.482,0L9.464,1.77a1.948,1.948,0,0,1-1.36.442L6.027,2.084A1.95,1.95,0,0,0,4.019,3.543L3.5,5.557a1.951,1.951,0,0,1-.841,1.157L.9,7.832a1.95,1.95,0,0,0-.767,2.36L.9,12.128a1.948,1.948,0,0,1,0,1.431L.136,15.494A1.95,1.95,0,0,0,.9,17.854l1.755,1.118A1.95,1.95,0,0,1,3.5,20.129l.52,2.015A1.95,1.95,0,0,0,6.027,23.6L8.1,23.475a1.95,1.95,0,0,1,1.36.442l1.605,1.324a1.95,1.95,0,0,0,2.482,0l1.605-1.324a1.95,1.95,0,0,1,1.36-.442l2.077.128A1.95,1.95,0,0,0,20.6,22.144c.177-.686.378-1.461.52-2.015a1.95,1.95,0,0,1,.841-1.157l1.755-1.118a1.95,1.95,0,0,0,.767-2.36l-.763-1.936a1.948,1.948,0,0,1,0-1.431l.763-1.936a1.95,1.95,0,0,0-.767-2.36L21.962,6.715a1.951,1.951,0,0,1-.841-1.157C20.978,5,20.778,4.23,20.6,3.543a1.95,1.95,0,0,0-2.007-1.459l-2.077.128a1.948,1.948,0,0,1-1.36-.442Z",
    transform: "translate(0 0)",
    fill: "#64e29a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1690",
    "data-name": "Path 1690",
    d: "M22.732,33.093a.875.875,0,0,1-.619-.256l-3.659-3.659a.875.875,0,1,1,1.237-1.237l2.944,2.944L28.292,23.3a.875.875,0,1,1,1.4,1.046l-6.262,8.395a.875.875,0,0,1-.638.35Z",
    transform: "translate(-11.482 -15)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedBadge);
export default __webpack_public_path__ + "static/media/verified-badge.0da449926ed646e41550990a2111834f.svg";
export { ForwardRef as ReactComponent };